import { Component, OnInit } from '@angular/core';
import * as L from 'leaflet';
import { DataService } from '../../../services/data.service';
import { ConfirmSentComponent } from '../../modals/confirm-sent/confirm-sent.component';
import { combineLatest, from, of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { InfoModalComponent } from '../../modals/info-modal/info-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import _ from "lodash";

@Component({
  selector: 'app-trip',
  templateUrl: './trip-management.component.html',
  styleUrls: ['./trip-management.component.scss']
})
export class TripManagementComponent implements OnInit {

  public leafletOptions: any;
  public layers: any[];
  public data = [];
  public pageSize = 5;
  public page = 1;
  public selectedMode: string;
  public selectedRoute: any;
  public isLoaded = false;

  projectId: number;
  created: boolean = false;

  private map: L.Map;
  private routeGroup: L.LayerGroup;
  private colors = {
    'SAFE': '#8cbf70',
    'OCCASIONALLY_UNSAFE': '#e8a453',
    'UNSAFE': 'red',
  };
  constructor(
    private service: DataService,
    private modalService: NgbModal,
    private route: Router,
    private userService: UserService
  ) {
  }

  ngOnInit() {
    this.projectId = this.userService.project.projectID.id;
    // this.userService.getUserInfo().subscribe(user => this.addHomeMarker());
    this.fetchData();
  }

  public select(route) {
    this.route.navigate(['/', 'management', 'trip', 'edit', `${route.entityID.id1.id}_${route.entityID.id2}`]);
  }

  private fetchData() {
    this.isLoaded = false;
    this.selectedRoute = null;
    this.selectedMode = null;
    combineLatest([
      this.service.genRouteCreated(this.projectId),
      this.service.getAllRoutes(),
    ]).pipe(
      tap(([created, routes]) => {
        this.created = created;
        this.data = routes;
        this.isLoaded = true;
      })).subscribe();
  }

  public remove(id) {
    const confirm = this.modalService.open(ConfirmSentComponent);
    confirm.componentInstance.data = {
      text: 'Are you sure you want to remove the route',
      header: 'Remove route'
    };
    from(confirm.result).pipe(
      tap(() => {
        if (this.routeGroup) {
          this.map.removeLayer(this.routeGroup);
        }
      }),
      switchMap(ok => this.service.removeRoute(id)),
      switchMap(response => {
        const infoDlg = this.modalService.open(InfoModalComponent);
        infoDlg.componentInstance.data = {
          text: 'The route has been deleted',
          header: 'Info'
        };
        return from(infoDlg.result);
      }),
      catchError(error => {
        if (error === 'no') {
          return of(error);
        }
        const infoDlg = this.modalService.open(InfoModalComponent);
        infoDlg.componentInstance.data = {
          text: `Internal Server Error \n ${error.error.message}`,
          header: 'Error'
        };
        return throwError(infoDlg.result);
      })
    ).subscribe(answer => this.fetchData());
  }

  public isChecked(it) {
    const project = JSON.parse(localStorage.getItem('project_id'));
    return !(it.genericAttributes.attributes.invisible_in_project || []).includes(project.projectID.id);
  }

  public updateVisibility(event, trip) {
    const project = JSON.parse(localStorage.getItem('project_id'));
    this.service.updateRouteVisibility(event.target.checked, project.projectID.id, trip.projectID.id, trip.entityID.id2).subscribe(() => {
      const infoDlg = this.modalService.open(InfoModalComponent);
      infoDlg.componentInstance.data = {
        text: 'The route has been updated',
        header: 'Info'
      };
      return from(infoDlg.result);
    });
  }

  addHomeMarker() {
    let userLocation = this.userService.user.attributes.location[0].coordinates;
    var homeMarker = L.marker(new L.LatLng(userLocation[1], userLocation[0]), {
      icon: L.icon({ iconUrl: 'assets/marker/home.png', iconSize: [57, 67], iconAnchor: [27, 66] }),
      draggable: true
    });

    homeMarker.bindTooltip(`${this.userService.user.attributes.address[0].street} ${this.userService.user.attributes.address[0].houseNumber}`);

    this.map.addLayer(homeMarker);
  }
}
